import React from 'react';
import { classNames } from '../../utils/style';

export type ColumnProps = {
  children: React.ReactNode;
  className?: string;
};

export const Column = ({
  children,
  className,
}: ColumnProps): React.ReactElement => {

  return <div className={classNames('Column', className)}>{children}</div>;
};
